import { styled } from '@mui/material';

const ToggleInput = styled("input")({
    opacity: 0,
    width: "100%",
    height: "100%",
    margin: 0,
    position: "absolute",
    inset: 0,
    cursor: "pointer",
});

export { ToggleInput };
//# sourceMappingURL=ToggleInput.js.map
